<template>
	<vSelect ref="select" :clearable="false" :searchable="searchable" :options="formattedOptions" @option:selected="($event) => $emit('change', $event)">
		<template #no-options="{ search, searching, loading }">
			Ingen resultater
		</template>
		<template #option="{ label, category, isShowCategory, status }">
			<div v-if="isShowCategory">
				<label class="d-block font-bold">{{ category }}</label>
			</div>
			<div :style="status === 'Block' ? 'font-style: italic' : null ">{{ label }}</div>
		</template>
	</vSelect>
</template>
<script setup>
import { computed, h, ref, watch } from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "@oldSrc/assets/vue-select.css";

const props = defineProps({
	options: Array,
	isCategories: Boolean,
	searchable: {
		type: Boolean,
		default: false,
	},
});
const select = ref(null);
const options = ref(props.options);

watch(
	() => props.options,
	(newOptions) => {
		options.value = newOptions;
	},
);

const formattedOptions = computed(() => {
	const newOptions = options.value;
	const placeHolder = newOptions?.find((value) => value.option === 0);

	const sortedOptions = props.isCategories
		? newOptions
				?.sort((a, b) => {
					if (a.option === 0) return -1;
					if (b.option === 0) return 1;
					if (a.category != b.category) {
						return a.category?.localeCompare(b.category);
					}
					return a.label.localeCompare(b.label);
				})
				.map((option, index) => ({
					...option,
					isShowCategory: isShowCategory(option, index),
				}))
		: newOptions;
	const uniqueOptions = placeHolder
		? [
				placeHolder,
				...sortedOptions.filter((option) => option.option !== 0),
			]
		: sortedOptions;

	return uniqueOptions;
});

const isShowCategory = (option, index) => {
	for (let i = 0; i < index; i++) {
		if (options.value[i].category === option.category) {
			return false;
		}
	}
	return true;
};

vSelect.props.components.default = () => ({
	OpenIndicator: {
		render: () =>
			h("span", {
				class: { toggle: true },
				innerHTML: '<b role="presentation"></b>',
			}),
	},
});
defineExpose({ select });
</script>
